import React, { useEffect, useState } from 'react';

import { OPTIMIZATION_TYPE, Task } from '@bringg/types';
import { getRootEnv } from '@bringg-frontend/bringg-web-infra';
import { ActionKey } from '@bringg-frontend/monitoring-shared';
import { Notification } from '@bringg/react-components';

import RoutesPlannerModal from 'bringg-web/components/routes-planner-modal/routes-planner-modal';

interface Props {
	selectedTasks: Task[];
	closeModal: (actionKey: ActionKey) => void;
}

const RoutesPlannerOpener = ({ closeModal, selectedTasks }: Props) => {
	const [fullDataTasks, setFullDataTasks] = useState<Task[]>();

	const getFullTasks = async (tasks: Task[]) => {
		const taskIds = tasks.map(task => task.id);
		try {
			const fullTasks = await getRootEnv().dashboardSdk.sdk.v2.tasks.loadMany(taskIds);
			setFullDataTasks(fullTasks);
		} catch (e) {
			console.error('error fetching tasks', e);
			Notification.error('ROUTE_MONITORING.ROUTES_PLANNER_OPEN_ERROR');
			return [];
		}
	};

	useEffect(() => {
		getFullTasks(selectedTasks);
	}, []);

	return (
		<>
			{fullDataTasks ? (
				<RoutesPlannerModal
					onClose={() => closeModal(ActionKey.routesPlanner)}
					modalParams={{
						optimizationResults: undefined,
						selectedTasks: fullDataTasks,
						optimizationType: OPTIMIZATION_TYPE.COMBINED,
						isManualOptimization: true,
						isOpenFromDispatch: selectedTasks[0].ready_to_execute,
						teamId: selectedTasks[0].team_ids[0]
					}}
				/>
			) : null}
		</>
	);
};

export default RoutesPlannerOpener;
